import React from 'react';  
import './index.css';
 import { List } from 'antd-mobile';
const Item = List.Item;
class ExcellentItem extends React.Component {
  render(){
    const {data,index,title} =this.props;
    return(
      <Item  thumb={<div className="work-num"><span>{index+1}</span></div>}> 
        <div className="work-list"> 
          <div className="work-name">{data.get('username')}</div>
          <div className="work-title">{data.get('subtitle')?data.get('subtitle'):(title?title
          :data.get('title'))}</div>
          <div className="work-score">{data.get('score')?data.get('score'):'0'}.0</div>
        </div>
      </Item>
      )
  }
}
export default ExcellentItem;